/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Platform = {
    _11184809: '11184809',
    ios: 'ios',
    android: 'android',
    web: 'web',
    other: 'other',
    unknown_default_open_api: '11184809'
} as const;
export type Platform = typeof Platform[keyof typeof Platform];


export function instanceOfPlatform(value: any): boolean {
    for (const key in Platform) {
        if (Object.prototype.hasOwnProperty.call(Platform, key)) {
            if (Platform[key as keyof typeof Platform] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PlatformFromJSON(json: any): Platform {
    return PlatformFromJSONTyped(json, false);
}

export function PlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): Platform {
    return json as Platform;
}

export function PlatformToJSON(value?: Platform | null): any {
    return value as any;
}

